import React from 'react';

const LoadingModal = ({ 
  isVisible, 
  appName,
  className = "",
  message = "Loading"
}) => {
  if (!isVisible) return null;

  return (
    <div 
      className={`fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 ${className}`}
      role="dialog"
      aria-label={`${message} ${appName}`}
      aria-modal="true"
    >
      <div className="bg-white rounded-2xl p-8 shadow-2xl text-center max-w-sm mx-4">
        <div 
          className="animate-spin w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full mx-auto mb-4"
          aria-hidden="true"
        />
        <p className="text-lg font-semibold text-gray-800">
          {message} {appName}...
        </p>
      </div>
    </div>
  );
};

export default LoadingModal;